import {i18n} from 'src/shared/config'

export const courierInfo = [
  {
    title: i18n(
      'order.form.courier-info.mileage-title',
      'Для маршрутов до 5,5 км',
    ),
    caption: i18n(
      'order.form.courier-info.mileage-caption',
      'Доставят на велосипеде или пешком',
    ),
  },
  {
    title: i18n(
      'order.form.courier-info.max-load-title',
      'Можно отправить до 10 кг',
    ),
    caption: i18n(
      'order.form.courier-info.max-load-caption',
      'У курьеров будет термосумка для еды',
    ),
  },
]
